import { ImBriefcase } from 'react-icons/im';
import { MdLaptop } from 'react-icons/md';
import { TbWorldSearch } from 'react-icons/tb';
import { FaLightbulb } from 'react-icons/fa6';
import { useRef, useState } from 'react';
import { BuildAppMobile, CloudAnimation, IoTAnimacion, LaptopAnimation, TransformationDigitalAnimation } from '../utils/Animations';
import { ParallaxText, SectionAnimation } from '../utils/AnimationFramerMotion';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import 'swiper/css';

export function Body({ data }) {
    const [tab, setTab] = useState(0);
    const swiperRef = useRef(null);
    const icons = [<ImBriefcase />, <MdLaptop />, <TbWorldSearch />, <FaLightbulb />];
    const animationsTabs = [<BuildAppMobile />, <LaptopAnimation />, <IoTAnimacion />, <CloudAnimation />, <TransformationDigitalAnimation />];
    const tabRefs = useRef(null);
    tabRefs.current = [];

    const addTabRef = (el) => {
        if (el && !tabRefs.current.includes(el))
            tabRefs.current.push(el);
    };

    const changeTab = (e, value) => {
        e.preventDefault();
        setTab(value);
        swiperRef.current.swiper.slideTo(value);
        viewTabSelected(value)
    }

    function viewTabSelected(value) {
        if (tabRefs.current[value]) {
            tabRefs.current[value].scrollIntoView({
                behavior: 'smooth',
                block: 'nearest',
                inline: 'nearest',
            });
        }
    }

    return (
        <section className='body-home'>
            <div className='bg-section-secondary'>
                <SectionAnimation
                    translateX='-400px'
                >
                    <div className='body-home__section-one container py-5 py-lg-0 d-flex flex-column justify-content-center'>
                        <h2 className='body-home__section-one__title text-center mb-4 mb-lg-5'>{data.sectionOneTitle}</h2>
                        <p className='body-home__section-one__description text-center mb-4 mb-lg-5'>{data.sectionOneDescription}</p>
                        <div className='body-home__cards row'>
                            {
                                data.sectionOneCards.map((card, index) => (
                                    <CardHome
                                        key={index}
                                        title={card.title}
                                        description={card.description}
                                        icon={icons[index]} />
                                ))
                            }
                        </div>
                    </div>
                </SectionAnimation>
            </div>

            <div className='bg-section-primary'>
                <SectionAnimation
                    translateX='400px'
                >
                    <div className='body-home__section-two container py-5 py-lg-0 d-flex flex-column justify-content-center position-relative'>
                        <div className='body-home__section-two__container row w-100 m-auto'>
                            {
                                data.sectionTwoImagesMobile.map((item, index) => (
                                    <ImageCollageHome
                                        key={index}
                                        imageMobile={item}
                                        imageDesktop={data.sectionTwoImagesDesktop[index]}
                                        descriptionImage={data.sectionTwoImagesDescription} />
                                ))
                            }
                        </div>
                        <div className='body-home__section-two__text position-absolute w-100 h-100 d-flex justify-content-center align-items-center'>
                            <div className='body-home__section-two__text-box bg-section-secondary p-4'>
                                <p className='body-home__section-two__text-box__paragraph m-0'>{data.sectionTwoDescription}</p>
                            </div>
                        </div>
                    </div>
                </SectionAnimation>
            </div>

            <div className='bg-section-secondary'>
                <SectionAnimation
                    translateX='-200px'
                >
                    <div className='body-home__section-three py-5 container py-lg-0 d-flex flex-column justify-content-center'>
                        <nav className='body-home__section-three__nav'>
                            <ul className='body-home__section-three__list d-flex justify-content-xl-center ps-0 m-0'>
                                {
                                    data.sectionThreeTabs.map((item, index) => (
                                        <li
                                            id={`item-${index}`}
                                            className={`body-home__section-three__item d-flex justify-content-center p-1 ${tab === (index) ? 'body-home__section-three__item--active' : ''}`}
                                            ref={addTabRef}
                                            key={index}
                                        >
                                            <a className='body-home__section-three__link text-center d-flex align-items-center' href={`#${item.link}`} onClick={(e) => changeTab(e, index)}>{item.tab}</a>
                                        </li>
                                    ))
                                }
                            </ul>
                        </nav>
                        <div className='body-home__section-three__content'>
                            <Swiper
                                ref={swiperRef}
                                spaceBetween={20}
                                slidesPerView={1}
                                pagination={{
                                    clickable: true
                                }}
                                modules={[Pagination]}
                                onSlideChange={
                                    (swiper) => {
                                        setTab(swiper.activeIndex);
                                        viewTabSelected(swiper.activeIndex);
                                    }
                                }
                            >
                                {
                                    data.sectionThreeTabs.map((item, index) => (
                                        <SwiperSlide
                                            className='w-100'
                                            key={index}
                                        >
                                            <ContentTab
                                                item={item}
                                                index={index}
                                                tab={tab}
                                                animationsTabs={animationsTabs} />
                                        </SwiperSlide>
                                    ))
                                }
                            </Swiper>
                        </div>
                    </div>
                </SectionAnimation>
            </div>

            <div className='bg-section-primary'>
                <SectionAnimation
                    translateX='200px'
                >
                    <div className='body-home__brands py-5 d-flex align-items-center'>
                        <div className='body-home__brands__container container'>
                            <h3 className='body-home__brands__title text-center'>{data.brandsTitle}</h3>
                            <p className='body-home__brands__description text-center mb-4 mb-lg-5'>{data.brandsDescription}</p>
                            <div className='body-home__brands__box row justify-content-center'>
                                {
                                    data.brands.map((item, index) => (
                                        <CardBrand
                                            key={index}
                                            data={item}
                                        />
                                    ))
                                }
                            </div>
                        </div>
                    </div>
                </SectionAnimation>
            </div>

            <div className='body-home__section-four bg-section-secondary'>
                <div className='body-home__section-four__parallax py-4 py-lg-5'>
                    <ParallaxText baseVelocity={-3}>Tech Mode</ParallaxText>
                </div>
                <div className='body-home__section-four__parallax py-4 py-lg-5'>
                    <ParallaxText baseVelocity={3}>Tech Mode</ParallaxText>
                </div>
            </div>

        </section>
    );
}

export function CardHome({ title, description, icon }) {
    return (
        <div className='card-home d-flex flex-column align-items-center col-sm-6 col-xl-3'>
            <div className='card-home__image mb-4 d-flex justify-content-center align-items-center'>
                {icon}
            </div>
            <p className='card-home__title text-center'>{title}</p>
            <p className='card-home__description text-center'>{description}</p>
        </div>
    );
}

export function ImageCollageHome({ imageMobile, imageDesktop, descriptionImage }) {
    return (
        <div className='body-home__section-two__image col-6'>
            <picture className='body-home__section-two__picture d-block position-relative'>
                <source srcSet={imageDesktop} media='(min-width: 576px)' />
                <img className='body-home__section-two__img w-100' src={imageMobile} srcSet={`${imageMobile} 2x, ${imageDesktop} 576w`} alt={descriptionImage} />
                <div className='body-home__section-two__overlay w-100 h-100 position-absolute'></div>
            </picture>
        </div>
    );
}

export function ContentTab({ item, index, animationsTabs }) {
    return (
        <div className={'body-home__section-three__content-box row'}>
            <div className='body-home__section-three__text pb-4 pb-xl-0 col-xl-6 order-2 order-xl-1'>
                <h3 className='body-home__section-three__title text-center text-xl-start mb-3 mb-lg-4'>{item.tab}</h3>
                {
                    item.description.map((paragraph, index) => (
                        <p className='body-home__section-three__description text-center text-xl-start' key={index}>{paragraph}</p>
                    ))
                }
            </div>
            <div className='body-home__section-three__image col-xl-6 order-1 order-xl-2 mb-4 mb-xl-0 d-flex justify-content-center align-items-center'>
                {/* <img className='body-home__section-three__img w-100' src={item.image} alt={item.descriptionImage} /> */}
                {
                    animationsTabs[index]
                }
            </div>
        </div>
    );
}

export function CardBrand({ data }) {
    return (
        <div className='card-brand col-12 col-md-6 col-lg-4 mb-4 mb-lg-0'>
            <div className='card-brand__image'>
                <img className='card-brand__img w-100' src={data.image} alt='Imagen de marca aliada' />
            </div>
            <div className='card-brand__text mt-3'>
                <p className='card-brand__title text-center mb-1'>{data.title}</p>
                <p className='card-brand__description text-center mb-0'>{data.description}</p>
            </div>
        </div>
    );
}

